import { Location } from "@angular/common";
import { Component, DoCheck, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AnalyticEvent } from "app/lib/analytic-event";
import { ApiService } from "app/lib/api.service";
import { LogService } from "app/lib/log.service";
import { SeriesService } from "app/lib/series.service";
import { UserService } from "app/lib/user.service";
import { Reads, voice } from "app/models/course";
import { User } from "app/models/user";

@Component({
    selector: 'app-org-series-content-view-all',
    templateUrl: './org-series-content-view-all.component.html',
    styleUrls: ['./org-series-content-view-all.component.scss'],
    standalone: false
})
export class OrgSeriesContentViewAllComponent implements OnInit, DoCheck {
title = "";
  user: User;
  lang: string = "en";
  videoSeriesList: any = [];
  voiceSeriesList: any = [];
  organizationOwnContentTitle: string = "";
  storySeriesList: voice[] = [];
  bqSeriesList: voice[] = [];
  viewAllListLoaded: boolean = false;
  
  readableSeriesList: Reads[] = [];
  type: string;
  showBreadcrumbs: boolean = true;
  constructor(
    private userService: UserService,
    private location: Location,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private seriesService: SeriesService,
    private api: ApiService,
    private log: LogService
  ) {
    this.user = this.userService.getUser();
    this.lang = this.translate.currentLang;
    this.showBreadcrumbs = this.user?.userType === 'user' ? true : false;
      this.organizationOwnContentTitle =
      this.user?.primaryOrganization?.settings[
        "organizationOwnContentTitle" + this.lang.replace(/^\w/, (c) => c.toUpperCase())
      ] || "";
    this.type = this.activatedRoute.snapshot.paramMap.get('type');
  }

  ngOnInit() {
    switch (this.type) {
      case 'videos':
        this.title = "series.seriesTypes.video";
        this.getVideoSeries();
        break;
      case 'stories':
        this.title = "series.orgOwnStories";
        this.getStorySerliesList();
        break;
      case 'burningQuestions':
        this.title = "series.orgOwnBurningQuestion";
        this.getBQSerliesList();
        break;
      case 'reads':
        this.title = "series.voiceSeries.reads";
        this.getReadableSeries();
        break;
  }
}
  ngDoCheck() {
    this.lang = this.translate.currentLang;
  }
  goBack() {
        this.location.back();
    }
  getVideoSeries() {
    this.viewAllListLoaded = false;
    this.seriesService
      .getOrgCustiomVideoSeriesList(this.user.primaryOrganization.id)
      .subscribe((data: any) => {
        if (data && data.length > 0) {
          this.videoSeriesList = data;
        }
        this.viewAllListLoaded = true;
      });
  }

  getStorySerliesList() {
    this.viewAllListLoaded = false;
    let payLoad = {
      CourseType: "organization",
    };
    this.api.get("series/stories", payLoad).subscribe(
      (response: any) => {
        this.storySeriesList = voice.initializeArray(
          response || [],
          "stories",
        );
        this.viewAllListLoaded = true;
      },
      (error) => {
        this.log.event(
          AnalyticEvent.internalPagesEvents.customOrgStorySeriesFetchError,
        );
      },
    );
  }

  getBQSerliesList() {
    this.viewAllListLoaded = false;
    let payLoad = {
      CourseType: "organization",
    };
    this.api.get("series/burningquestions", payLoad).subscribe(
      (response: any) => {
        this.viewAllListLoaded = true;
        this.bqSeriesList = voice.initializeArray(
          response || [],
          "burningQuestion",
        );
      },
      (error) => {
        this.log.event(
          AnalyticEvent.internalPagesEvents
            .customOrgBurningQuestionSeriesFetchError,
        );
      },
    );
  }

  getReadableSeries() {
    this.viewAllListLoaded = false;
    let payLoad = {
      CourseType: "organization",
    };
    this.seriesService
      .getOrgCustiomReadableSeriesList(this.user.primaryOrganization.id, payLoad)
      .subscribe((data: any) => {
        if (data && data.length > 0) {
          this.readableSeriesList = data || [];
        }
        this.viewAllListLoaded = true;
      });
  }
  goToVideoSeries(series) {
    this.router.navigate(["/app/series/org-series-contents/video/" + series.courseKey]);
  }
  goToVoice(type: string, series) {
    this.router.navigate([
      "/app/series/org-series-contents/voices/" + type + "/" + series.id,
    ]);
  }
  goToReadableSeries(item: any) {
      window.open(item.fileUrl, "_blank");
      this.log.event(
        AnalyticEvent.internalPagesEvents.customOrgReadItemClicked, '',
        { title: item["title" + this.lang] },
      );
      this.api.post("series/reads/count/" + item.id, {}).subscribe(
        (result: any) => {},
        (error: any) => {
          this.log.error("Error logging link click");
        },
      );
    }
}
